import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../../auth/stores/authStore';
import { getOffboardReadiness } from '../api/userManagementApi';
import { userKeys } from './userKeys';

export const useOffboardReadiness = (userId: string | null) => {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: userKeys.offboardReadiness(userId || ''),
    queryFn: () => getOffboardReadiness(userId!),
    enabled: isAuthenticated && !!userId,
  });
};
